export default __webpack_public_path__ + "static/media/rs-arte-8.3c35b341.webp";